const Zones = require("../data/game/pvp-zones.json");

export default {
	Zones,
};
